<template>
  <div>
    <div class="title-row mb-4">
      <h2>Precautions</h2>
    </div>
    <!-- /// Data Table /// -->
    <div class="table-wrapper">
      <v-data-table :headers="headers" :items="precautions" :items-per-page="10" class="elevation-1 fixed-action" item-key="key">
        <template v-slot:[`item.urdu`]="{ item }">
          <h2>
            {{ item.value.urdu }}
          </h2>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex align-center">
            <v-btn v-if="item.value.visible" class="mr-3" color="primary" @click="toggleVisibility(item.value)">
              <v-icon class="mdi mdi-eye"></v-icon>
            </v-btn>
            <v-btn v-else color="primary" class="mr-3" @click="toggleVisibility(item.value)">
              <v-icon class="mdi mdi-eye-off"></v-icon>
            </v-btn>
            <v-btn color="primary" @click="upsertPreset(item.value)">
              <v-icon class="mdi mdi-pencil"></v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="upsertDialog" class="medicine-modal" width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.selectedPrecaution.name ? "Edit" : "Add" }} Precaution Preset</span>
          <v-btn
              density="default"
              color="primary"
              size="small"
              icon="mdi-close"
              @click="upsertDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="pt-9 pb-5">
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
              <v-text-field variant="outlined" color="primary" v-model="selectedPrecaution.name" label="Diagnosis Name"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
              <v-text-field variant="outlined" color="primary" reverse v-model="selectedPrecaution.urdu" label="Urdu"></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex align-center justify-end mt-3">
            <v-btn color="primary" text @click="getUrdu">Get Urdu</v-btn>
            <v-btn color="primary" class="ml-3" text @click="upsertDialog = false">Cancel</v-btn>
            <v-btn color="primary" class="ml-3" text @click="savePreset">Save</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { VDataTable } from "vuetify/labs/VDataTable";
import { db } from "../../db";
import { drugTypes, dosages, medroutes } from "../config";
import { post } from "@/apiClient";
export default {
  name: "SettingsTabPrecautions",
  components: {
    VDataTable,
  },
  mounted() {
    this.loadPrecautions();
  },
  methods: {
    getUrdu() {
      post("urdu", { english: this.selectedPrecaution.name }).then((res) => {
        this.selectedPrecaution.urdu = res.data;
      }).catch((err) => {
        console.log(err);
      })
    },
    loadPrecautions() {
      let linkkey = this.$route.params.linkkey;
      db.appobjects
        .where({ linkkey: linkkey, type: "precaution" })
        .toArray()
        .then((precautions) => {
          console.log("precautions", precautions);
          this.precautions = precautions;
        });
    },
    async savePreset() {
      if (this.selectedPrecaution.key) {
        this.selectedPrecaution.modified = Date.now();
        this.selectedPrecaution.synced = 0;
        await db.appobjects.update(this.selectedPrecaution.key, JSON.parse(JSON.stringify(this.selectedPrecaution)));
        this.upsertDialog = false;
        this.loadPrecautions();
      }
      // this.loadDrugs();
      this.selectedPrecaution = {
        key: "",
        name: "",
        urdu: "",
      }
    },
    async toggleVisibility(item) {
      item.visible = !item.visible;
      item.synced = 0;
      item.modified = Date.now();
      item = JSON.parse(JSON.stringify(item));
      await db.appobjects.update(item.key, item);
       this.loadPrecautions();
    },
    upsertPreset(preset = null) {
      if (preset) {
        this.selectedPrecaution = preset;
        this.upsertDialog = true;
      }
    },
  },
  data: () => ({
    precautions: [],
    upsertDialog: false,
    selectedPrecaution: null,
    headers: [
      {
        title: "Precaution Name",
        key: "key",
        sortable: true,
        value: "name",
      },
      {
        title: "Urdu",
        key: "urdu",
        sortable: true,
        value: "urdu",
      },
      {
        title: "Action",
        key: "action",
        sortable: false,
        value: "action",
      }
    ]


  }),
  computed: {
    drugTypes() {
      return drugTypes;
    },
    dosages() {
      return dosages;
    },
    medroutes() {
      return medroutes;
    },
  },

}
</script>

<style scoped>

.fixed-action:deep(table th:last-of-type) {
  right: 0;
  position: sticky;
}
.fixed-action:deep(table td:last-of-type) {
  right: 0;
  position: sticky;
}

</style>